import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { comTelaEstreita } from "../../../utils/viewport";

interface Props {
  url?: string;
  telaEstreita?: boolean;
}

const navegadorSemLeitorDePdf = () => (window.navigator as any).pdfViewerEnabled === false;

const ponteiroPrincipalEToque = () =>
  typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;

// iOS declara leitor de PDF, mas o embed mostra so a primeira pagina sem rolagem
const deveAbrirEmNovaAba = (telaEstreita?: boolean) =>
  navegadorSemLeitorDePdf() || (!!telaEstreita && ponteiroPrincipalEToque());

export const VisualizadorDocumento: React.FC<Props> = ({ url, telaEstreita }) => {
  if (deveAbrirEmNovaAba(telaEstreita)) {
    return (
      <div style={{ padding: 24, textAlign: "center" }}>
        <Typography variant="body1" style={{ marginBottom: 16 }}>
          O documento está pronto. Toque no botão abaixo para abri-lo.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component="a"
          {...({ href: url, target: "_blank", rel: "noopener noreferrer" } as any)}
        >
          Abrir documento
        </Button>
      </div>
    );
  }
  return <embed src={url} type="application/pdf" style={{ width: "100%", height: "calc(100vh - 64px)" }} />;
};

export default comTelaEstreita(VisualizadorDocumento);
